import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { ISearchResult, ISearchResultsGrouped } from 'redux-state/search/types.js';
import { algoliaSearchIndex, AlgoliaSearchResultType } from './algolia.js';
import {
  REDUX_SEARCH_ASYNC,
  REDUX_SEARCH_CLEAR_RESULTS,
  REDUX_SEARCH_ERROR,
  REDUX_SEARCH_SUCCESS,
  SearchAsyncReducerType,
} from './reducer.js';

function* search(action: SearchAsyncReducerType) {
  const { query } = action.payload;

  if (!query) {
    yield put(REDUX_SEARCH_CLEAR_RESULTS());
    return;
  }

  try {
    const content: AlgoliaSearchResultType = yield call(algoliaSearchIndex, query);
    const { hits: results } = content;
    const formattedResults = {
      length: results.length,
      groupedResults: results.reduce<ISearchResultsGrouped['groupedResults']>((grouped, result: ISearchResult) => {
        const { type } = result;
        if (!grouped[type]) {
          grouped[type] = [];
        }
        grouped[type].push(result);
        return grouped;
      }, {}),
    };

    yield put(REDUX_SEARCH_SUCCESS({ results: formattedResults }));
  } catch {
    yield put(REDUX_SEARCH_ERROR());
  }
}

export default function* searchSaga(): IterableIterator<ForkEffect<never>> {
  const searchType = REDUX_SEARCH_ASYNC({ query: '' }).type;
  yield takeLatest(searchType, search);
}
